import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import AuthApi from "../../api/authApi";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import AuthShell from "./AuthShell";
import { evaluatePasswordStrength } from "../../utils/passwordRules";
import { trimIfOnChangeField } from "../../utils/trimFormFields";

const ChangePassword: React.FC = () => {
  let history = useNavigate();
  const location = useLocation();
  const [isError, setIsError] = useState<boolean>(false);
  const [isSpaceOrSyb, setIsSpaceOrSyb] = useState<boolean>(false);
  const [validated, setValidated] = useState<boolean>(false);
  let api = new AuthApi();
  const [data, setData] = useState<Record<string, any>>({
    email: "",
    otp: "",
    newpassword: "",
    re_pass: "",
  });

  const [cp, setCp] = useState<boolean>(false);

  useEffect(() => {
    const email = (location.state as any)?.emailaddress;
    if (email) {
      let d = { ...data };
      d.email = typeof email === "string" ? email.trim() : email;
      setData(d);
    } else {
      history("/forgetPassword");
    }
  }, []);

  const handleChanges = async (e: any) => {
    let { name, value } = e.target;
    if (typeof value === "string") value = trimIfOnChangeField(name, value);
    let d = { ...data };
    d[name] = value;
    if (name === "newpassword") {
      const { isStrong, hasDisallowedChars } = evaluatePasswordStrength(
        value,
        /[!@#\\$%\\^&\\*,_ -. +, =,!, %, *, &, ”, :, .,]/g,
        /[~,\\,<, ,]/g,
      );
      setIsSpaceOrSyb(hasDisallowedChars);
      setIsError(!isStrong);
      d.password = value;
    }
    if (name === "re_pass") {
      if (d.re_pass !== d.newpassword) {
        setCp(true);
      } else {
        setCp(false);
      }
    } else if (d.re_pass) {
      if (d.re_pass !== d.newpassword) {
        setCp(true);
      } else {
        setCp(false);
      }
    }
    setData(d);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (!isError) {
      if (form.checkValidity()) {
        api
          .ResetPassWord(data)
          .then((res: any) => {
            if (res.success) {
              toast.success(res.msg);
              history("/login");
            } else {
              toast.error(res.msg);
            }
          })
          .catch((error: any) => {
            toast.error(error);
          });
      }
    }
    setValidated(true);
  };

  return (
    <AuthShell
      title="Reset password"
      subtitle="Enter the OTP from your email and choose a new password."
      showBackToLogin
    >
      <Form
        noValidate
        validated={validated}
        className="auth-modern-form"
        onSubmit={handleSubmit}
      >
        <Form.Group className="auth-field">
          <Form.Label>OTP</Form.Label>
          <Form.Control
            required
            type="number"
            className="form-control form-control-sm border-left-0"
            placeholder="Enter OTP"
            name="otp"
            value={data.otp}
            onChange={(e) => handleChanges(e)}
          />
          <Form.Control.Feedback type="invalid">
            OTP is requried
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="auth-field">
          <Form.Label>New Password</Form.Label>
          <Form.Control
            required
            type="password"
            className="form-control form-control-sm border-left-0"
            placeholder="Enter new password"
            name="newpassword"
            value={data.newpassword}
            isInvalid={isError}
            onChange={(e) => handleChanges(e)}
          />
          <Form.Control.Feedback type="invalid">
            {data.password === "" ? (
              "Password is required"
            ) : isSpaceOrSyb ? (
              "Do not use a space or tab and these characters \\, ~ or <"
            ) : (
              <>
                Your password isn’t strong enough It should be minimum 8
                characters <br></br> with at least one special and one capital
                and small letter.
              </>
            )}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="auth-field">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            required
            type="password"
            className="form-control form-control-sm border-left-0"
            placeholder="Re-enter password"
            name="re_pass"
            value={data.re_pass}
            onChange={(e) => handleChanges(e)}
            isInvalid={cp}
          />
          <Form.Control.Feedback type="invalid">
            password is not matching
          </Form.Control.Feedback>
        </Form.Group>

        <Button
          type="submit"
          className="auth-submit mt-2"
          disabled={cp ? true : false}
        >
          Reset Password
        </Button>
      </Form>
    </AuthShell>
  );
};

export default ChangePassword;
